import React from 'react';

import { Container, Img, Text,Details } from './styles';
import { BUSINESS } from '../../../constants/urls';

const NoBusiness = () =>(
    <Container>
      <Img src={BUSINESS} alt="" />
      <Text>No business found</Text>
      <Details>
        <span>Please add your business by visiting </span>
        <span><strong>einv.cleartax.in</strong> from your</span>
        <span> desktop to start using the app.</span>
      </Details>
  </Container>
  );

export default NoBusiness
